"use client";

import { useCartStore } from "@/providers/cart-store-provider";
import { CartItem } from "@/stores/cart-store";
import { XIcon } from "lucide-react";
import React from "react";

export default function RemoveProduct({ product }: { product: CartItem }) {
  const removeFromCart = useCartStore((state) => state.removeFromCart);
  return (
    <>
      <button
        className="border border-transparent hover:border-primary rounded-full hover:bg-muted"
        aria-label={`remove ${product.name} from cart`}
        onClick={() => removeFromCart(product.databaseId)}
      >
        <XIcon className="text-primary size-6" />
      </button>
    </>
  );
}
